export const SET_CONVERSATION                       = 'SET_CONVERSATION';
export const APPEND_CONVERSATIONS                   = 'APPEND_CONVERSATIONS';
export const NEW_MESSAGE_EVENT                      = 'NEW_MESSAGE_EVENT';
export const NEW_CURRENT_CONTACT_DISABLED           = 'NEW_CURRENT_CONTACT_DISABLED';
export const SET_ACTIVE_CONTACT_ID                  = 'SET_ACTIVE_CONTACT_ID';
export const TERMINATE_CONVERSATION                 = 'TERMINATE_CONVERSATION';
export const SET_SINGLE_CONTACT_CONVERSATIONS       = 'SET_SINGLE_CONTACT_CONVERSATIONS';
export const SET_SINGLE_CONTACT_ACTIVE_CONVERSATION = 'SET_SINGLE_CONTACT_ACTIVE_CONVERSATION';
export const RESET_SINGLE_CONTACT_CONVERSATION      = 'RESET_SINGLE_CONTACT_CONVERSATION';
